import { Table } from "components/styleguide";
import { ForumSeminarSessionsImportItem } from "generated/api";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.less";

interface Props {
  loading: boolean;
  rows: ForumSeminarSessionsImportItem[];
}

const ConferenceTimingsTable = ({ rows, loading }: Props) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("Facility Code"),
      dataIndex: "facilityCode",
    },
    {
      title: t("Event Code"),
      dataIndex: "forumCode",
    },
    {
      title: t("Seminar Code"),
      dataIndex: "seminarCode",
    },
    {
      title: t("Places"),
      dataIndex: "places",
    },
    {
      title: t("Start Time"),
      dataIndex: "startTime",
    },
    {
      title: t("Stop Time"),
      dataIndex: "stopTime",
    },
  ];

  return (
    <Table
      loading={loading}
      columns={columns}
      dataSource={rows}
      rowKey={"index"}
      rowClassName={(row) => (row.isValidItem ? "" : styles.invalid)}
    />
  );
};

export default ConferenceTimingsTable;
